import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IRequisitionItemFields {
		id?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		requisitionId?: any;
		jobId?: any;
		taxCodeId?: any;
		requisitionPartialId?: any;
		dueDate?: any;
		qty?: any;
		procurementOfficeUserId?: any;
		buyerUserId?: any;
		latestRequisitionItemWorkflowId?: any;
		stockItemSupplierId?: any;
		inStock?: any;
		sivNumber?: any;
		generalLedgerId?: any;
		hierarchyId?: any;
		price?: any;
		isStandardItem?: any;
		taxable?: any;
		nonStandardItemDescription?: any;
		approvalRequested?: any;
		approvalGranted?: any;
		supplierId?: any;
		approvalRejected?: any;
		stockItemId?: any;
		jobSpecific?: any;
		projectJobNumberId?: any;
		standardItemSupplierNotLinked?: any;
		unitPrice?: any;
		sisProLineNum?: any;
		sysproError?: any;
		sysproImportedFlag?: any;
		sysproPo?: any;
		sysproReceivedQty?: any;
		sysproOrderCompleted?: any;
  sysproTimestamp?: any;
  warehouseId?: any;
  variant?: any;
  sivRequired?: any;
}

export class RequisitionItemFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public requisitionId: IEntityModelField = { name: "requisitionId", displayName: "Requisition Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public jobId: IEntityModelField = { name: "jobId", displayName: "Job Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public taxCodeId: IEntityModelField = { name: "taxCodeId", displayName: "Tax Code Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public requisitionPartialId: IEntityModelField = { name: "requisitionPartialId", displayName: "Requisition Partial Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public dueDate: IEntityModelField = { name: "dueDate", displayName: "Due Date", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public qty: IEntityModelField = { name: "qty", displayName: "Qty", fieldType: FieldType.Float, pattern: "NameGeneric", required: true };
	public procurementOfficeUserId: IEntityModelField = { name: "procurementOfficeUserId", displayName: "Procurement Office User Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public buyerUserId: IEntityModelField = { name: "buyerUserId", displayName: "Buyer User Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public latestRequisitionItemWorkflowId: IEntityModelField = { name: "latestRequisitionItemWorkflowId", displayName: "Latest Requisition Item Workflow Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public stockItemSupplierId: IEntityModelField = { name: "stockItemSupplierId", displayName: "Stock Item Supplier Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public inStock: IEntityModelField = { name: "inStock", displayName: "In Stock", fieldType: FieldType.Byte, pattern: "NameGeneric" };
	public sivNumber: IEntityModelField = { name: "sivNumber", displayName: "Siv Number", fieldType: FieldType.String, pattern: "NameGeneric" };
	public generalLedgerId: IEntityModelField = { name: "generalLedgerId", displayName: "General Ledger Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public hierarchyId: IEntityModelField = { name: "hierarchyId", displayName: "Hierarchy Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public price: IEntityModelField = { name: "price", displayName: "Price", fieldType: FieldType.Float, pattern: "NameGeneric" };
	public isStandardItem: IEntityModelField = { name: "isStandardItem", displayName: "Is Standard Item", fieldType: FieldType.Byte, pattern: "NameGeneric" };
	public taxable: IEntityModelField = { name: "taxable", displayName: "Taxable", fieldType: FieldType.Byte, pattern: "NameGeneric" };
	public nonStandardItemDescription: IEntityModelField = { name: "nonStandardItemDescription", displayName: "Non Standard Item Description", fieldType: FieldType.String, pattern: "NameGeneric" };
	public approvalRequested: IEntityModelField = { name: "approvalRequested", displayName: "Approval Requested", fieldType: FieldType.Byte, pattern: "NameGeneric" };
	public approvalGranted: IEntityModelField = { name: "approvalGranted", displayName: "Approval Granted", fieldType: FieldType.Byte, pattern: "NameGeneric" };
	public supplierId: IEntityModelField = { name: "supplierId", displayName: "Supplier Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public approvalRejected: IEntityModelField = { name: "approvalRejected", displayName: "Approval Rejected", fieldType: FieldType.Byte, pattern: "NameGeneric" };
	public stockItemId: IEntityModelField = { name: "stockItemId", displayName: "Stock Item Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public jobSpecific: IEntityModelField = { name: "jobSpecific", displayName: "Job Specific", fieldType: FieldType.Byte, pattern: "NameGeneric" };
	public projectJobNumberId: IEntityModelField = { name: "projectJobNumberId", displayName: "Project Job Number Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public standardItemSupplierNotLinked: IEntityModelField = { name: "standardItemSupplierNotLinked", displayName: "Standard Item Supplier Not Linked", fieldType: FieldType.Byte, pattern: "NameGeneric" };
	public unitPrice: IEntityModelField = { name: "unitPrice", displayName: "Unit Price", fieldType: FieldType.Float, pattern: "NameGeneric" };
	public sisProLineNum: IEntityModelField = { name: "sisProLineNum", displayName: "Sis Pro Line Num", fieldType: FieldType.Int, pattern: "NameGeneric" };
	public sysproError: IEntityModelField = { name: "sysproError", displayName: "Syspro Error", fieldType: FieldType.String, pattern: "NameGeneric" };
	public sysproImportedFlag: IEntityModelField = { name: "sysproImportedFlag", displayName: "Syspro Imported Flag", fieldType: FieldType.String, pattern: "NameGeneric" };
	public sysproPo: IEntityModelField = { name: "sysproPo", displayName: "Syspro Po", fieldType: FieldType.String, pattern: "NameGeneric" };
	public sysproReceivedQty: IEntityModelField = { name: "sysproReceivedQty", displayName: "Syspro Received Qty", fieldType: FieldType.Float, pattern: "NameGeneric" };
	public sysproOrderCompleted: IEntityModelField = { name: "sysproOrderCompleted", displayName: "Syspro Order Completed", fieldType: FieldType.String, pattern: "NameGeneric" };
  public sysproTimestamp: IEntityModelField = { name: "sysproTimestamp", displayName: "Syspro Timestamp", fieldType: FieldType.String, pattern: "NameGeneric" };
  public warehouseId: IEntityModelField = { name: "warehouseId", displayName: "Warehouse Id", fieldType: FieldType.String, pattern: "NameGeneric" };

  public variant: IEntityModelField = { name: "variant", displayName: "Item Variant", fieldType: FieldType.String, pattern: "NameGeneric" };
  public invoiceNo: IEntityModelField = { name: "invoiceNo", displayName: "Invoice / Quote No", fieldType: FieldType.String, pattern: "NameGeneric" };

  public invoiceNoDuplicated: IEntityModelField = { name: "invoiceNoDuplicated", displayName: "Invoice No already used on another req", fieldType: FieldType.String, pattern: "NameGeneric" };
  public sivRequired: IEntityModelField = { name: "sivRequired", displayName: "SIV Required", fieldType: FieldType.Byte, pattern: "NameGeneric" };
  public discountPrice: IEntityModelField = { name: "discountPrice", displayName: "Discount %", fieldType: FieldType.Float, pattern: "NameGeneric" };
  public uom: IEntityModelField = { name: "unitPrice", displayName: "Unit Of Measure", fieldType: FieldType.String, pattern: "NameGeneric" };



	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.requisitionId);
		this.push(this.jobId);
		this.push(this.taxCodeId);
		this.push(this.requisitionPartialId);
		this.push(this.dueDate);
		this.push(this.qty);
		this.push(this.procurementOfficeUserId);
		this.push(this.buyerUserId);
		this.push(this.latestRequisitionItemWorkflowId);
		this.push(this.stockItemSupplierId);
		this.push(this.inStock);
		this.push(this.sivNumber);
		this.push(this.generalLedgerId);
		this.push(this.hierarchyId);
		this.push(this.price);
		this.push(this.isStandardItem);
		this.push(this.taxable);
		this.push(this.nonStandardItemDescription);
		this.push(this.approvalRequested);
		this.push(this.approvalGranted);
		this.push(this.supplierId);
		this.push(this.approvalRejected);
		this.push(this.stockItemId);
		this.push(this.jobSpecific);
		this.push(this.projectJobNumberId);
		this.push(this.standardItemSupplierNotLinked);
		this.push(this.unitPrice);
		this.push(this.sisProLineNum);
		this.push(this.sysproError);
		this.push(this.sysproImportedFlag);
		this.push(this.sysproPo);
		this.push(this.sysproReceivedQty);
		this.push(this.sysproOrderCompleted);
      this.push(this.sysproTimestamp);
      this.push(this.warehouseId)
    this.push(this.variant);
    this.push(this.invoiceNo);
    this.push(this.sivRequired)
	}
}

export class RequisitionItemDTO implements IEntityModel {
	protected requisitionItemName: string = "RequisitionItemModel";
	protected requisitionItemKeyField: string = "id";
	protected requisitionItemDisplayName: string = "Requisition Item|Requisition Items";
	protected requisitionItemFields = new RequisitionItemFields();
	public get name(): string { return this.requisitionItemName };
	public get keyField(): string { return this.requisitionItemKeyField };
	public get displayName(): string { return this.requisitionItemDisplayName };
	public get fields(): RequisitionItemFields { return this.requisitionItemFields };

	constructor() {};
}
